import { useTheme } from "../theme"

export const DisconnectedIcon = () => {
  const theme = useTheme()
  const fill = theme.palette.full.red
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 11C22 17.0752 17.0752 22 11 22C4.92484 22 0 17.0752 0 11C0 4.92484 4.92484 0 11 0C17.0752 0 22 4.92484 22 11Z"
        fill={fill}
      />
      <path
        d="M6.12295 14.9991L6.12315 14.9993C6.12275 14.9997 6.12235 14.9997 6.12235 14.9997L5.79383 15.3292C5.50198 15.622 5.50199 16.0967 5.79583 16.3897C5.94236 16.5352 6.13377 16.6084 6.3252 16.6084C6.51762 16.6084 6.70984 16.5352 6.85636 16.3877L7.18448 16.0586L7.77739 15.4659L6.71666 14.4053L6.12295 14.9991Z"
        fill="white"
      />
      <path
        d="M6.8001 11.1259C6.76302 12.2969 7.18575 13.3857 7.99252 14.1915C8.76583 14.965 9.7991 15.3867 10.9154 15.3867C10.9623 15.3867 11.01 15.3857 11.0579 15.3837C11.5299 15.3691 11.9865 15.2618 12.4253 15.1039L7.08072 9.75913C6.92257 10.1979 6.81533 10.6543 6.8001 11.1259Z"
        fill="white"
      />
      <path
        d="M14.2341 13.9385L15.2305 12.9413C15.5234 12.6485 15.5234 12.1738 15.2305 11.8808L14.6404 11.2909L16.7451 9.2079C17.0401 8.91686 17.0421 8.44141 16.7511 8.14737C16.461 7.85352 15.9844 7.84951 15.6905 8.14155L13.5799 10.2302L11.9357 8.58613L14.0245 6.47549C14.3155 6.18164 14.3135 5.70599 14.0185 5.41495C13.7236 5.12391 13.249 5.12592 12.9579 5.42077L10.8751 7.5256L10.3037 6.95394C10.0106 6.6611 9.536 6.6611 9.24316 6.95394L8.24616 7.95093L5.91022 5.61519C5.71479 5.41996 5.39829 5.41996 5.20306 5.61519C5.00783 5.81042 5.00783 6.12692 5.20306 6.32215L15.9014 17.0195C15.999 17.1171 16.1269 17.166 16.255 17.166C16.3829 17.166 16.5107 17.1171 16.6086 17.0195C16.8038 16.8243 16.8038 16.508 16.6086 16.3125L14.2341 13.9385Z"
        fill="white"
      />
    </svg>
  )
}
